import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/Statistics.css';

const statistics = [
  {
    number: '90M+ Digital Bean Tokens',
    description: 'Digi Bean Tokens Available in Koffieland.',
    image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_1.png'
  },
  {
    number: '2 min 47 secs',
    description: 'Average delivery time from order to doorstep.',
    image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_1.png'
  },
 {    number: '100+ Partners',
      description: 'Over 100 partners in the Koffieland network.',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_1.png'
 }
];

const Statistics = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % statistics.length);
    }, 5000); // Change every 5 seconds (adjust as needed)

    return () => clearInterval(interval);
  }, []);

  const variants = {
    enter: { opacity: 0, scale: 0.8 },
    center: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.8 }
  };

  return (
    <section className="statistics-section" id="statistics">
      <div className="container">
      <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#statistics" className="section-link">Numbers</a>
          <h2 className="news-title">The Digtal Wave</h2>
        </motion.div>
        <div className="statistics-container">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              className="statistic-item"
              initial="enter"
              animate="center"
              exit="exit"
              variants={variants}
              transition={{ duration: 0.6 }}
            >
              <div className="text-content">
                <h2 className="statistic-number">{statistics[current].number}</h2>
                <p className="statistic-description">{statistics[current].description}</p>
              </div>
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              key={`img-${current}`}
              className="statistic-image"
              initial="enter"
              animate="center"
              exit="exit"
              variants={variants}
              transition={{ duration: 0.6 }}
            >
              <img src={statistics[current].image} alt="Statistic" />
            </motion.div>
          </AnimatePresence>
        </div>

        
      </div>
    </section>
  );
};

export default Statistics;
